import React from 'react';
import { Slide } from "react-reveal";
import bull from "../../assets/images/icons/bull.svg";
import eye from "../../assets/images/icons/eye.svg";

const Mission = () => {
    return (
      <Slide top>
        <div className="mission-side">
          <div className="mission-item">
            <img src={bull} alt="Mission" />
            <div>
              <h2>Mission</h2>
              <p>
                To inspire and empower a community of responsible dog owners by
                offering comprehensive, expert-led training programs, breeding
                and Accommodation.
              </p>
            </div>
          </div>
          <div className="mission-item">
            <img src={eye} alt="Vision" />
            <div>
              <h2>Vision</h2>
              <p>
                To be the World leading Center for Canine Research, training and
                development.
              </p>
            </div>
          </div>
        </div>
      </Slide>
    );
}
 
export default Mission;